import { render } from "./DiscountToast.vue?vue&type=template&id=4397aa3e&scoped=true"
import script from "./DiscountToast.vue?vue&type=script&lang=js"
export * from "./DiscountToast.vue?vue&type=script&lang=js"

import "./DiscountToast.vue?vue&type=style&index=0&id=4397aa3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4397aa3e"]])

export default __exports__